<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
			<div class="center-nav">
				<span class="hidden-xs">您的位置：</span>
				<router-link :to="{name:'home'}">首页</router-link><i>&gt;</i>
				<a title="个人中心" href="#">个人中心</a>
			</div>
			<div class="center-container">
				<div class="center-container-left">
					<div class="center-container-left-Ltitle">
						<ul>
							<li>
								<a class="active" title="我的咨询" @click="show('1')">我的咨询</a>
							</li>
							<li>
								<a class="active" title="我的预约" @click="show('2')">我的预约</a>
							</li>
							<li>
								<a class="active" title="我的申办" @click="show('3')">我的申办</a>
							</li>
							<li>
								<a class="active" title="修改密码" @click="show('4')">修改密码</a>
							</li>
						</ul>
						<div class="left-pic">
							<img src="./../assets/img/left-pic.png" alt="">
						</div>
					</div>
				</div>
				<!-- 咨询 -->
				<div class="center-container-right" v-if="pages=='1'">
					<div class="center-container-right-title">
						<span class="title">我的咨询</span>
					</div>
					<div class="center-container-right-words">
						<div style="padding: 20px 20px;" v-if="zxlist">
							<el-table class="integralTable" :data="zxlist" style="width: 100%;">
								<el-table-column align="center" prop="name" label="姓名" min-width="10%">
								</el-table-column>
								<el-table-column align="center" prop="phone" label="手机号码" min-width="15%">
								</el-table-column>
								<el-table-column align="center" prop="content" :show-overflow-tooltip='true'
									label="咨询内容" min-width="50%">
									<template slot-scope="scope">
										<span>{{scope.row.content}}</span>
									</template>
								</el-table-column>
								</el-table-column>
								<el-table-column align="center" prop="state" label="状态" min-width="10%">
									<template slot-scope="scope">
										<span v-if="scope.row.state == '1'">已回复</span>
										<span v-else>未回复</span>
									</template>
								</el-table-column>
								<el-table-column align="center" label="操作" min-width="10%">
									<template slot-scope="scope">
										<a style="cursor:pointer;" @click="openmsg(scope.row)">详情</a>
									</template>
								</el-table-column>
							</el-table>
							<el-dialog title="公证员回复" :visible.sync="open" width="40%" :show-close="false" v-if="zxdata">
								<el-descriptions class="margin-top" title="" :column="2" border>
									<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
										<template slot="label">
											<i class="el-icon-user"></i>
											咨询人
										</template>
										{{zxdata.name}}
									</el-descriptions-item>
									<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
										<template slot="label">
											<i class="el-icon-mobile-phone"></i>
											手机号码
										</template>
										{{zxdata.phone}}
									</el-descriptions-item>
									<el-descriptions-item labelStyle="width:100px;min-width: 100px;text-align: center;">
										<template slot="label">
											<i class="el-icon-chat-square"></i>
											咨询内容
										</template>
										{{zxdata.content}}
									</el-descriptions-item>
								</el-descriptions>

								<div class="reply_box" v-if="zxdata.state == '1'">
									<div style="padding: 15px 0px;">回复内容：
										<div style="color:#94572C;line-height: 24px;text-indent:2em;padding: 10px 0px;">
											{{zxdata.replycontent}}
										</div>
									</div>
									<div>回复时间：{{zxdata.reviewerdatetime}}</div>
								</div>
								<div class="reply_box" v-else>
									<h4>暂未回复，请耐心等待...</h4>
								</div>

							</el-dialog>
						</div>
						<div style="padding: 20px 20px;" v-else>
							<el-empty description="暂无咨询"></el-empty>
						</div>
					</div>
				</div>

				<!-- 预约 -->
				<div class="center-container-right" v-if="pages=='2'">
					<div class="center-container-right-title">
						<span class="title">我的预约</span>
					</div>
					<div class="center-container-right-words">
						<div style="padding: 20px 20px;" v-if="yylist">
							<el-table :data="yylist" class="aaaa" style="width: 100%;">
								<el-table-column align="center" prop="name" label="姓名" min-width="10%">
								</el-table-column>
								<el-table-column align="center" prop="phone" label="手机号码" min-width="15%">
								</el-table-column>
								<el-table-column align="center" prop="matter" label="预约事项" min-width="15%">
									<template slot-scope="scope">
										<span>{{scope.row.matter}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="matter" label="预约时间" min-width="16%">
									<template slot-scope="scope">
										<span>{{scope.row.appointmentdate + ' ' + scope.row.appointmenttime}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="category" label="公证员回复"
									:show-overflow-tooltip='true' min-width="20%">
									<template slot-scope="scope">
										<span>{{scope.row.reviewercontent}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="scheduletime" label="公证员安排时间" min-width="20%">
								</el-table-column>
							</el-table>
						</div>
						<div style="padding: 20px 20px;" v-else>
							<el-empty description="暂无预约"></el-empty>
						</div>
					</div>
				</div>

				<!-- 申办 -->
				<div class="center-container-right" v-if="pages=='3'">
					<div class="center-container-right-title">
						<span class="title">我的申办</span>
					</div>
					<div class="center-container-right-words">
						<div style="padding: 20px 20px;" v-if="sblist">
							<el-table :data="sblist" class="aaaa" style="width: 100%;">
								<el-table-column align="center" prop="businessid" label="申请编号" min-width="15%">
								</el-table-column>
								<el-table-column align="center" prop="allmatter" label="申请事项" min-width="15%">
								</el-table-column>
								<el-table-column align="center" prop="appletsBusinessMatter" label="申请人"
									min-width="10%">
									<template slot-scope="scope">
										<span
											v-for="(item,index) in scope.row.appletsBusinessMatter" v-if="index==0">{{item.party}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="operatortime" label="申请时间" min-width="18%">
									<template slot-scope="scope">
										<span>{{scope.row.operatortime}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="state" label="状态" min-width="15%">
									<template slot-scope="scope">
										<span v-if="scope.row.state == '0'">补充材料</span>
										<span v-else-if="scope.row.state == '2'">已审核</span>
										<span v-else-if="scope.row.state == '98'">已拒绝</span>
										<span v-else-if="scope.row.state == '99'">已撤销</span>
										<span v-else>待审核</span>
									</template>
								</el-table-column>
								<el-table-column :show-overflow-tooltip='true' align="center" prop="remarks"
									label="审核意见" min-width="20%">
									<template slot-scope="scope">
										<span>{{scope.row.remarks}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" label="费用支付" min-width="10%">
									<template slot-scope="scope">
										<el-link v-if="scope.row.state == '2'" type="primary" @click="pay">费用支付</el-link>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div style="padding: 20px 20px;" v-else>
							<el-empty description="暂无申办"></el-empty>
						</div>
					</div>
				</div>

				<!-- 修改密码 -->
				<div class="center-container-right" v-if="pages=='4'">
					<div class="center-container-right-title">
						<span class="title">修改密码</span>
					</div>
					<div class="center-container-right-words">
						<div style="align-items: center;text-align: center;">
							<el-form :model="form" :rules="rules" ref="form" class="form" style="width: 100%;">
								<el-form-item prop="phone">
									<!-- <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号码">
										<i slot="prefix" class="el-icon-mobile-phone"></i>
									</el-input> -->
								</el-form-item>
								<el-form-item prop="oldPassword">
									<el-input v-model="form.oldPassword" maxlength="11" placeholder="请输入原密码">
										<i slot="prefix" class="el-icon-mobile-phone"></i>
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="form.password" maxlength="20" placeholder="请输入新密码">
										<i slot="prefix" class="el-icon-unlock"></i>
									</el-input>
								</el-form-item>
								<el-form-item prop="pass">
									<el-input v-model="form.pass" maxlength="20" placeholder="请确认密码">
										<i slot="prefix" class="el-icon-unlock"></i>
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button @click="submit" type="danger" style="width: 50%;">修改密码</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>

			</div>
		</div>
		
		
		<el-dialog
		  title="费用支付"
		  :visible.sync="showpay"
		  width="30%"
		  :before-close="handleClose"  :show-close="false"
		  >
		      <el-image
		        :src="imgurl"
		        fit="fill"></el-image>
		</el-dialog>
		
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {
		getConsultingList,
		getAppointmentList,
		order,
		webChangePassWord
	} from '../api/indexapp.js'
	export default {
		name: "userhome",
		components: {
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '个人中心-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '个人中心'
			}],
		},
		data() {
			return {
				imgurl:require('@/assets/img/56381647914069_.pic.jpg'),
				showpay:false,
				pages: '1',
				zxlist: [],
				open: false,
				zxdata: null,
				yylist: null,
				sblist: null,
				form: {
					phone: null,
					oldPassword: null,
					password: null,
					pass: null
				},
				rules: {

					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度在11个字符',
							trigger: 'blur'
						}
					],
					oldPassword: [{
							required: true,
							message: '请输入原密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					pass: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
				}
			}
		},
		created() {
			this.$nextTick(() => {
				this.pages = this.$route.params.page;
				if (this.pages == '1') {
					this.getzx();
				} else if (this.pages == '2') {
					this.getyy();
				} else if (this.pages == '3') {
					this.getsb();
				} else {

				}
			})
		},
		methods: {
			handleClose(){
				this.showpay = false;
			},
			pay(){
				this.showpay = true;
			},
			submit(){
				if(this.form.pass != this.form.password){
					this.$message.error('两次输入的密码不一致！');
				}else{
					this.$refs['form'].validate((valid) => {
						if (valid) {
							webChangePassWord(this.form).then(res=>{
								if(res.code == 200){
									this.$message('修改密码成功');
									this.form = {}
								}else{
									this.$message.error(res.msg);
								}
							})
						}
					})
				}
				
			},
			openmsg(row) {
				this.zxdata = row;
				this.open = true;
			},
			show(row) {
				this.pages = row;
				if (this.pages == '1') {
					this.getzx();
				} else if (this.pages == '2') {
					this.getyy();
				} else if (this.pages == '3') {
					this.getsb();
				} else {

				}
			},
			getzx() {
				getConsultingList().then(res => {
					this.zxlist = res.data
				})
			},
			getyy() {
				getAppointmentList().then(res => {
					this.yylist = res.data
				})
			},
			getsb() {
				order().then(res => {
					console.log(res)
					this.sblist = res.data
				})
			}
		},
		// 监听路由
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.pages = val.params.page;
					if (this.pages == '1') {
						this.getzx();
					} else if (this.pages == '2') {
						this.getyy();
					} else if (this.pages == '3') {
						this.getsb();
					} else {

					}
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";

	.reply_box {
		padding: 30px 0px;
	}
	
	.el-tooltip__popper {
		max-width: 300px;
	}
</style>
